import Loader from 'components/Loader';

const routes = [
	{
		key: '/list/lis/prompts',
		path: '/list/lis/prompts',
		layout: 'list',
		sideMenu: true,
		label: 'Prompts',
		container: Loader(() => import('components/LIS/PromptList')),
		containerProps: {},
	},
];

export default routes;
